// Rotation helper for curated motivational message pools.
// The pools themselves live in /src/i18n/translations.js (en + pl).

const dayOfYear = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  return Math.floor((now - start) / 86400000);
};

// Deterministic-within-a-day rotation; `salt` (e.g. activity count) varies per action
export const pickMessage = (pool, salt = 0) => {
  if (!pool || pool.length === 0) return "";
  const idx = (dayOfYear() + salt) % pool.length;
  return pool[idx];
};
